import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../../../atoms/Icon'
import { ICON_NAMES } from '../../../../../constants'

/**
 * Collapsible column header component for column groups
 * Shows a +/- icon to expand/collapse child columns
 */
const CollapsibleColumnHeader = ({
  header,
  isCollapsed,
  onToggle,
  className,
  headerClassName
}) => {
  const handleClick = (e) => {
    e.stopPropagation() // Prevent sort trigger
    onToggle()
  }

  return (
    <div className={clsx('__collapsible-column-header', className)}>
      <span className={clsx('__header-text', headerClassName)}>
        {header}
      </span>
      <button
        className='__collapse-toggle'
        onClick={handleClick}
        aria-label={isCollapsed ? 'Expand column group' : 'Collapse column group'}
        aria-expanded={!isCollapsed}
        type='button'
      >
        <Icon
          name={isCollapsed ? ICON_NAMES.addCircle : ICON_NAMES.removeCircle}
          className='collapse-icon'
        />
      </button>
    </div>
  )
}

CollapsibleColumnHeader.propTypes = {
  header: PropTypes.node.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  headerClassName: PropTypes.string
}

export default CollapsibleColumnHeader
